import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { INavigation } from '../../interfaces/interface';

@Component({
  selector: 'app-dashboard',
  imports: [TranslocoModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  @Input({ required: true }) public listMenuItems: INavigation[] = [];

  constructor(private readonly router: Router) {}

  public routeTo(route: string): void {
    this.router.navigate([route]);
  }
  public ngOnInit(): void {}
}
